/* eslint-disable */
export const sortByName = (a, b) => {
  const nameA = a.name.trim().toLowerCase();
  const nameB = b.name.trim().toLowerCase();

  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

export const sortByKey = (key) => (a, b) => {
  const valueA = a[key].trim().toLowerCase();
  const valueB = b[key].trim().toLowerCase();

  if (valueA < valueB) return -1;
  if (valueA > valueB) return 1;
  return 0;
};